.buttons {
  width: 100%;
}

.container {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0NoYW5nZVBhc3N3b3JkRm9ybSIsInNvdXJjZXMiOlsiY2xhc3Nlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJOzs7QUFHSjtFQUNJIiwic291cmNlc0NvbnRlbnQiOlsiLmJ1dHRvbnMge1xuICAgIHdpZHRoOiAxMDAlO1xufVxuXG4uY29udGFpbmVyIHtcbiAgICB3aWR0aDogMTAwJTtcbn1cbiJdfQ== */